<template>
	<gc-dialog
		:title="formValues ? '更新运营商平台' : '新增运营商平台'"
		width="760px"
		:show.sync="visible"
		@close="$emit('close-modal')"
		@cancel="$emit('close-modal')"
		@ok="handleSubmitForm"
		:okLoading="requestLoading"
	>
		<el-form :model="modelForm" :rules="rules" ref="modelForm" label-position="top" label-width="100px">
			<div class="form-block">
				<div class="title">平台信息</div>
				<el-row :gutter="12">
					<el-col :span="12">
						<el-form-item prop="appId">
							<el-input
								size="small"
								v-model="modelForm.appId"
								:disabled="Boolean(formValues)"
								placeholder="请输入"
								@change="handleAppIdChange"
							>
								<i v-if="searchIng" slot="suffix" class="el-input__icon el-icon-loading"></i>
							</el-input>
							<template #label>
								<p>
									APP_ID
									<span v-if="!formValues" class="appid_search" @click="handleFindPlatformProduct">
										查询
									</span>
								</p>
							</template>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="appCode" prop="platformCode">
							<el-input
								size="small"
								v-model="modelForm.platformCode"
								disabled
								placeholder="根据appId查询获取"
							></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="运营商" prop="platformType">
							<el-select
								v-model="modelForm.platformType"
								placeholder="请选择"
								:disabled="Boolean(formValues)"
								@change="handlePlatformTypeChange"
							>
								<el-option
									v-for="item in platformTypeOptions"
									:key="item.value"
									:label="item.label"
									:value="item.value"
								></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="平台名称" prop="platformName">
							<el-input size="small" v-model="modelForm.platformName" placeholder="请输入"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="产品ID" prop="productId">
							<el-input
								size="small"
								v-model="modelForm.productId"
								:disabled="Boolean(formValues)"
								placeholder="请输入"
							></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12" v-if="!modelForm.platformCode">
						<el-form-item label="运营商平台地址" prop="applicationAddr">
							<el-input size="small" v-model="modelForm.applicationAddr" placeholder="请输入"></el-input>
						</el-form-item>
					</el-col>
					<el-col
						:span="12"
						v-if="modelForm.platformType === 'OneNETNew' && !formValues && !modelForm.platformCode"
					>
						<el-form-item label="accessKey" prop="accessKey">
							<el-input size="small" v-model="modelForm.accessKey" placeholder="请输入"></el-input>
						</el-form-item>
					</el-col>
					<el-col
						:span="12"
						v-if="
							['HWIoT', 'AEP'].includes(modelForm.platformType) && !formValues && !modelForm.platformCode
						"
					>
						<el-form-item label="设备模型" prop="deviceModelCode">
							<el-select v-model="modelForm.deviceModelCode" placeholder="请选择">
								<el-option
									v-for="item in deviceModelCodeOptions"
									:key="item.value"
									:label="item.label"
									:value="item.value"
								></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col
						:span="12"
						v-if="['AEP'].includes(modelForm.platformType) && !formValues && !modelForm.platformCode"
					>
						<el-form-item label="masterKey" prop="masterKey">
							<el-input size="small" v-model="modelForm.masterKey" placeholder="请输入"></el-input>
						</el-form-item>
					</el-col>
					<el-col
						:span="12"
						v-if="
							['HWIoT', 'AEP'].includes(modelForm.platformType) && !formValues && !modelForm.platformCode
						"
					>
						<el-form-item label="secret" prop="secret">
							<el-input size="small" v-model="modelForm.secret" placeholder="请输入"></el-input>
						</el-form-item>
					</el-col>
					<el-col
						:span="12"
						v-if="
							['OneNET', 'OneNETNew'].includes(modelForm.platformType) &&
							!formValues &&
							!modelForm.platformCode
						"
					>
						<el-form-item label="streamId" prop="streamId">
							<el-select v-model="modelForm.streamId" placeholder="请选择">
								<el-option
									v-for="item in streamIdOptions"
									:key="item.value"
									:label="item.label"
									:value="item.value"
								></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col
						:span="12"
						v-if="['OneNETNew'].includes(modelForm.platformType) && !formValues && !modelForm.platformCode"
					>
						<el-form-item label="userId" prop="userId">
							<el-input size="small" v-model="modelForm.userId" placeholder="请输入"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="备注" prop="remarks" style="margin-bottom: 6px">
							<el-input
								type="textarea"
								v-model="modelForm.remarks"
								placeholder="请输入备注"
								:rows="3"
								resize="none"
							></el-input>
						</el-form-item>
					</el-col>
				</el-row>
			</div>
			<div class="form-block">
				<div class="title">权限控制</div>
				<el-col :span="24">
					<el-form-item label="" prop="publicFlag" style="margin-bottom: 0">
						<el-radio-group v-model="modelForm.publicFlag">
							<el-radio v-for="item in PLATFORM_PERMISSION_OPTIONS" :label="item.value" :key="item.value">
								{{ item.label }}
							</el-radio>
						</el-radio-group>
					</el-form-item>
				</el-col>
				<el-col :span="24">
					<div class="permission-desc-title">权限说明</div>
					<p class="desc-item">1. 编辑权限：当前厂商下的员工可编辑</p>
					<p class="desc-item">2. 使用权限：私有权限仅当前厂商下员工可使用，公开权限所有员工可使用</p>
				</el-col>
			</div>
		</el-form>
		<gc-dialog
			title="选择平台产品"
			width="720px"
			:show.sync="platformProductSelectVisible"
			:append-to-body="true"
			ok-text="确 定"
			@ok="handleConfirmPlatformProduct"
			@cancel="handleClosePlatformProduct"
			@close="handleClosePlatformProduct"
		>
			<gc-table
				ref="platformProductTable"
				border
				:columns="platformProductColumns"
				:table-data="platformProductOptions"
				:total-hide="false"
				:is-highlight-current="true"
				@row-click="handleSelectPlatformProduct"
			></gc-table>
		</gc-dialog>
	</gc-dialog>
</template>

<script>
import { ruleRequired, ruleMaxLength } from '@/utils/rules'
import { PLATFORM_PERMISSION_OPTIONS } from '@/config/const'
import {
	apiCreatePlatformProduct,
	apiFindPlatformProduct,
	apiUpdatePlatformProduct,
} from '@/apis/communicationModelManage.api'
export default {
	props: {
		formValues: {
			type: Object,
			default: () => null,
		},
	},
	data() {
		return {
			PLATFORM_PERMISSION_OPTIONS,
			visible: true,
			modelForm: {
				appId: null,
				platformName: null,
				platformCode: null,
				platformType: null,
				productId: null,
				applicationAddr: null,
				accessKey: null,
				deviceModelCode: null,
				masterKey: null,
				secret: null,
				streamId: null,
				userId: null,
				remarks: null,
				publicFlag: 0,
			},
			rules: {
				appId: [ruleRequired()],
				platformName: [ruleRequired()],
				platformType: [ruleRequired('请选择')],
				productId: [ruleRequired()],
				applicationAddr: [ruleRequired()],
				accessKey: [ruleRequired()],
				deviceModelCode: [ruleRequired('请选择')],
				masterKey: [ruleRequired()],
				secret: [ruleRequired()],
				streamId: [ruleRequired()],
				userId: [ruleRequired()],
				remarks: [ruleMaxLength(200)],
			},
			requestLoading: false,
			searchIng: false,
			platformProductSelectVisible: false,
			platformProductOptions: [],
			selectedPlatformProduct: null,
			platformProductColumns: [
				{ key: 'platformCode', name: 'appCode', minWidth: 140, tooltip: true },
				{ key: 'platformType', name: '运营商', minWidth: 120, tooltip: true },
				{ key: 'productId', name: '产品ID', minWidth: 150, tooltip: true },
				{ key: 'platformName', name: '平台名称', minWidth: 180, tooltip: true },
			],
		}
	},

	created() {
		this.updateFormValuesSet()
	},

	methods: {
		updateFormValuesSet() {
			if (this.formValues) {
				const {
					appId,
					platformCode,
					platformId,
					platformName,
					platformType,
					publicFlag,
					productId,
					remarks,
				} = this.formValues
				Object.assign(this.modelForm, {
					appId,
					platformCode,
					platformId,
					platformName,
					platformType,
					publicFlag,
					productId,
					remarks,
				})
			}
		},

		handleSubmitForm() {
			this.$refs.modelForm.validate(async valid => {
				if (valid) {
					this.requestLoading = true
					const API = this.formValues ? apiUpdatePlatformProduct : apiCreatePlatformProduct
					try {
						await API({
							...this.modelForm,
							manufacturerId: this.manufacturerId,
						})
						this.$message.success('操作成功')
						this.$emit('close-modal', true)
					} finally {
						this.requestLoading = false
					}
				}
			})
		},

		async handleFindPlatformProduct() {
			try {
				await this.formValidFields(['appId'])
				this.searchIng = true
				const data = await apiFindPlatformProduct(this.modelForm.appId)
				const platformProducts = Array.isArray(data) ? data : data ? [data] : []
				this.platformProductOptions = platformProducts
				if (!platformProducts.length) {
					this.clearPlatformProduct()
					this.$message.warning('未查询到平台信息')
					return
				}
				if (platformProducts.length === 1) {
					this.fillPlatformProduct(platformProducts[0])
					return
				}
				this.clearPlatformProduct()
				this.selectedPlatformProduct = null
				this.platformProductSelectVisible = true
			} finally {
				this.searchIng = false
			}
		},

		handleAppIdChange() {
			this.clearPlatformProduct()
			this.platformProductOptions = []
			this.selectedPlatformProduct = null
			this.platformProductSelectVisible = false
		},

		fillPlatformProduct(platformProduct) {
			const { platformCode, platformType, productId } = platformProduct
			Object.assign(this.modelForm, {
				platformCode,
				platformType,
				productId,
			})
			this.handlePlatformTypeChange(platformType)
		},

		clearPlatformProduct() {
			Object.assign(this.modelForm, {
				platformCode: null,
				platformType: null,
				productId: null,
			})
		},

		handleSelectPlatformProduct({ row }) {
			this.selectedPlatformProduct = row
		},

		handleConfirmPlatformProduct() {
			if (!this.selectedPlatformProduct) {
				this.$message.warning('请选择平台产品')
				return
			}
			this.fillPlatformProduct(this.selectedPlatformProduct)
			this.platformProductSelectVisible = false
		},

		handleClosePlatformProduct() {
			this.platformProductSelectVisible = false
		},

		formValidFields(fieldName) {
			return new Promise((resolve, reject) => {
				this.$refs.modelForm.validateField(fieldName, errorMessage => {
					if (errorMessage) {
						reject(errorMessage)
					} else {
						resolve()
					}
				})
			})
		},

		handlePlatformTypeChange(platformTypeName) {
			this.modelForm.platformName = `${platformTypeName}_${this.tenantName}_${this.manufacturerName}`
		},
	},

	computed: {
		tenantId() {
			return this.$store.getters.userInfo.tenantId || null
		},

		tenantName() {
			return this.$store.getters.userInfo.tenantName || null
		},

		manufacturerId() {
			return this.$store.getters.userInfo.manufacturerId
		},

		manufacturerName() {
			return this.$store.getters.userInfo.manufacturerName || null
		},

		platformTypeOptions() {
			return (this.$store.getters.dataList?.platformType || []).map(m => {
				return {
					label: m.name,
					value: m.defaultValue,
				}
			})
		},

		deviceModelCodeOptions() {
			return (this.$store.getters.dataList?.deviceModelCode || []).map(m => {
				return {
					label: m.name,
					value: m.defaultValue,
				}
			})
		},

		streamIdOptions() {
			return (this.$store.getters.dataList?.streamId || []).map(m => {
				return {
					label: m.name,
					value: m.defaultValue,
				}
			})
		},
	},
}
</script>
<style lang="scss" scoped>
.form-block {
	.appid_search {
		font-size: 14px;
		color: #4d6bff;
		cursor: pointer;
		user-select: none;
	}
	& + .form-block {
		margin-top: 12px;
	}
	.title {
		font-size: 17px;
		margin-bottom: 8px;
		color: #000;
		display: flex;
		justify-content: space-between;
	}

	.permission-desc-title {
		color: #333;
		line-height: 24px;
		margin: 6px 0;
	}
	.desc-item {
		color: #999;
		line-height: 20px;
	}
}
</style>
